const CATEGORY_FOLDERS = new Set([
  "Calidades",
  "Print",
  "Ficha Diseño",
  "Ficha Técnica",
  "3D",
  "Patrones",
]);
const TECH_FOLDERS = new Set([
  "Ficha Diseño",
  "Ficha Técnica",
  "3D",
  "Patrones",
]);
const TECH_PATH_RE =
  /\/(Ficha T[eé]cnica|Ficha Dise[nñ]o|3D|Patrones)(?:\/|$)/i;

/** Infer category from API field or path (.../Muestras/{name}/Calidades/...) */
export function getMuestraFileCategory(file) {
  if (file?.category && CATEGORY_FOLDERS.has(file.category)) {
    return file.category;
  }
  const path = String(file?.path || "").replace(/\\/g, "/");
  const match = path.match(
    /\/Muestras\/[^/]+\/(Calidades|Print|Ficha Dise[nñ]o|Ficha T[eé]cnica|3D|Patrones)(?:\/|$)/i,
  );
  if (!match) return null;
  // Normalize accented folder names to canonical TECH_FOLDERS keys
  const raw = match[1];
  if (/^Calidades$/i.test(raw)) return "Calidades";
  if (/^Print$/i.test(raw)) return "Print";
  if (/^3D$/i.test(raw)) return "3D";
  if (/^Patrones$/i.test(raw)) return "Patrones";
  if (/^Ficha Dise/i.test(raw)) return "Ficha Diseño";
  if (/^Ficha T/i.test(raw)) return "Ficha Técnica";
  return raw;
}

export function isMuestraCategoryFile(file, category) {
  const fileCategory = getMuestraFileCategory(file);
  if (category) return fileCategory === category;
  return Boolean(fileCategory);
}

export function isTechnicalFilePath(filePath = "") {
  return TECH_PATH_RE.test(String(filePath).replace(/\\/g, "/"));
}

export function isTechnicalMuestraFile(file) {
  const category = getMuestraFileCategory(file);
  if (category && TECH_FOLDERS.has(category)) return true;
  return isTechnicalFilePath(file?.path);
}

/** Sample gallery photos only (no Calidades / Print / tech folders) */
export function filterMuestraGeneralFiles(files = []) {
  return files.filter((file) => !getMuestraFileCategory(file));
}

export function filterMuestraCategoryFiles(files = [], category) {
  return files.filter((file) => getMuestraFileCategory(file) === category);
}

export function filterMuestraTechnicalFiles(files = []) {
  return files.filter((file) => isTechnicalMuestraFile(file));
}

/**
 * Excel / Archivos: prefer root sample photos; if none, fall back to technical sheets.
 */
export function pickFilesForMuestraExportPhoto(files = []) {
  const samplePhotos = filterMuestraGeneralFiles(files);
  const technicalPhotos = filterMuestraTechnicalFiles(files);
  return (samplePhotos.length > 0 ? samplePhotos : technicalPhotos).slice(
    0,
    4,
  );
}
